import { createSelector } from 'reselect';
import { OrderedSet } from 'immutable';

import { State } from 'reducers';
import { selectDonations } from 'entities/donation/selectors';

import { ExternalDonationRequestsState, initialState } from './reducer';

const selectState = (state: State): ExternalDonationRequestsState =>
  state.get('externalDonationRequests') || initialState;

export const selectStatusUpdating = createSelector(
  selectState,
  (state: ExternalDonationRequestsState) => state.get('statusUpdating')
);

export const selectLoading = createSelector(selectState, (state: ExternalDonationRequestsState) =>
  state.get('loading')
);

export const selectError = createSelector(selectState, (state: ExternalDonationRequestsState) =>
  state.get('error')
);

export const selectFetchParams = createSelector(
  selectState,
  (state: ExternalDonationRequestsState) => state.get('fetchParams')
);

export const selectTotal = createSelector(selectState, (state: ExternalDonationRequestsState) =>
  state.get('total')
);

export const selectDisplayedDonations = createSelector(
  selectDonations,
  selectState,
  (donations, state) => {
    const displayedDonationIds: OrderedSet<string> = state.get('displayedDonationIds');
    return displayedDonationIds
      .map((donationId) => !!donationId && donations.get(donationId))
      .filter((donation) => !!donation && donation.status !== 'Pending');
  }
);
